type BaseEvent = {
  url: string;
  profileId: number;
  channelId: string;
  customerId: number;
  conversationId: string;
  captureLeadEnabled: boolean;
  pageTitle: string;
};

export const WebchatTactfulEvents = {
  WidgetLoaded: 'WEBCHAT_WIDGET_LOADED',
  WidgetOpened: 'WEBCHAT_WIDGET_OPENED',
  WidgetClosed: 'WEBCHAT_WIDGET_CLOSED',
  LeadCaptured: 'WEBCHAT_LEAD_CAPTURED',
} as const;

export type WebchatEvents = {
  [WebchatTactfulEvents.WidgetLoaded]: BaseEvent;
  [WebchatTactfulEvents.WidgetOpened]: BaseEvent;
  [WebchatTactfulEvents.WidgetClosed]: BaseEvent;
  [WebchatTactfulEvents.LeadCaptured]: BaseEvent;
};

export type WebchatTactfulEventsNames =
  (typeof WebchatTactfulEvents)[keyof typeof WebchatTactfulEvents];
